import { AxiosInstance } from "axios";
import { FAQ } from "../models/faq";

const FAQS_API_PREFIX = "/faqs/faqs";

export const getFAQs = async (http: AxiosInstance): Promise<FAQ[]> => {
	const response = await http.get<FAQ[]>(`${FAQS_API_PREFIX}/`);
	return response.data;
};
